// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"455":"286c7087d8c2dd1f","548":"1469564ecc287dd6","732":"0fc3e448f0c17d24","916":"e23b000441ea803c"}[chunkId] + ".js";
};